import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import { fallbackServices } from '../../data/fallbackData';
import { serviceTitle } from '../../utils/serviceDisplay';
import { enrichServicesFromApi } from '../../utils/enrichServicesFromApi';
import PhoneInput from '../PhoneInput/PhoneInput';
import api from '../../api';
import './BookingForm.css';

const BookingForm = () => {
  const { t, lang, phone } = useTranslation();
  const [services, setServices] = useState(fallbackServices);
  const [formData, setFormData] = useState({
    name: '', phone: '', car: '', service: '', date: '', comment: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/api/services')
      .then(res => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          setServices(enrichServicesFromApi(res.data));
        }
      })
      .catch(() => {
        setServices(fallbackServices);
      });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone) {
      setStatus({ type: 'error', message: t('contact.errorRequired') });
      return;
    }
    const digits = formData.phone.replace(/\D/g, '');
    if (digits.length < 11) {
      setStatus({ type: 'error', message: t('contact.errorPhone') });
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/api/booking', formData);
      setStatus({ type: 'success', message: res.data.message || 'Заявка отправлена!' });
      setFormData({ name: '', phone: '', car: '', service: '', date: '', comment: '' });
    } catch {
      setStatus({ type: 'error', message: t('contact.errorSend') });
    }
    setLoading(false);
    setTimeout(() => setStatus({ type: '', message: '' }), 5000);
  };

  const serviceList = Array.isArray(services) ? services : [];

  return (
    <section id="booking" className="section section-dark">
      <div className="container">
        <div className="booking__grid">
          <div className="booking__info">
            <h2 className="section-title" style={{ color: '#fff' }}>{t('booking.title')}</h2>
            <p className="booking__text">{t('booking.text')}</p>
            <div className="booking__benefits">
              {['benefit1', 'benefit2', 'benefit3', 'benefit4'].map(key => (
                <div key={key} className="booking__benefit">
                  <span>✅</span><span>{t(`booking.${key}`)}</span>
                </div>
              ))}
            </div>
            <div className="booking__contact">
              <p>{t('booking.orCall')}</p>
              <a href={`tel:${phone.replace(/\s/g, '')}`} className="booking__phone">{phone}</a>
            </div>
          </div>
          <form className="booking__form" onSubmit={handleSubmit}>
            <div className="booking__form-row">
              <div className="booking__field">
                <label>{t('booking.nameLabel')} *</label>
                <input type="text" name="name" value={formData.name}
                  onChange={handleChange} placeholder={t('booking.namePlaceholder')} required />
              </div>
              <div className="booking__field">
                <label>{t('booking.phoneLabel')} *</label>
                <PhoneInput name="phone" value={formData.phone} onChange={handleChange} required />
              </div>
            </div>
            <div className="booking__form-row">
              <div className="booking__field">
                <label>{t('booking.carLabel')}</label>
                <input type="text" name="car" value={formData.car}
                  onChange={handleChange} placeholder={t('booking.carPlaceholder')} />
              </div>
              <div className="booking__field">
                <label>{t('booking.serviceLabel')}</label>
                <select name="service" value={formData.service} onChange={handleChange}>
                  <option value="">{t('booking.serviceDefault')}</option>
                  {serviceList.map(s => (
                    <option key={s.id} value={serviceTitle(s, lang)}>{serviceTitle(s, lang)}</option>
                  ))}
                </select>
              </div>
            </div>            <div className="booking__field">
              <label>{t('booking.dateLabel')}</label>
              <input type="date" name="date" value={formData.date}
                onChange={handleChange} min={new Date().toISOString().split('T')[0]} />
            </div>
            <div className="booking__field">
              <label>{t('booking.commentLabel')}</label>
              <textarea name="comment" value={formData.comment}
                onChange={handleChange} placeholder={t('booking.commentPlaceholder')} rows={3} />
            </div>
            {status.message && (
              <div className={`booking__status booking__status--${status.type}`}>
                {status.type === 'success' ? '✅' : '❌'} {status.message}
              </div>
            )}
            <button type="submit" className="btn btn-primary btn-lg"
              style={{ width: '100%' }} disabled={loading}>
              {loading ? t('booking.sending') : t('booking.submit')}
            </button>
            <p className="booking__privacy">{t('booking.privacy')}</p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default BookingForm;
